export default __webpack_public_path__ + "static/Client-Testimonial-May Tan-437ce7c274025e7761e54975b21c21c9.png";